import axios from 'axios';

const API_BASE = '/api/consumables';

const withType = (catalogType, params = {}) => ({
  ...params,
  catalogType: catalogType || 'consumable'
});

export const consumableService = {
  getCategories: async (params = {}, catalogType = 'consumable') => {
    const response = await axios.get(`${API_BASE}/categories`, {
      params: withType(catalogType, params)
    });
    return response.data;
  },

  createCategory: async (data, catalogType = 'consumable') => {
    const response = await axios.post(`${API_BASE}/categories`, {
      ...data,
      catalog_type: catalogType
    });
    return response.data;
  },

  updateCategory: async (id, data) => {
    const response = await axios.put(`${API_BASE}/categories/${id}`, data);
    return response.data;
  },

  deleteCategory: async (id) => {
    const response = await axios.delete(`${API_BASE}/categories/${id}`);
    return response.data;
  },

  getItems: async (params = {}, catalogType = 'consumable') => {
    const response = await axios.get(`${API_BASE}/items`, {
      params: withType(catalogType, params)
    });
    return response.data;
  },

  getLowStock: async (catalogType = 'consumable') => {
    const response = await axios.get(`${API_BASE}/items/low-stock`, {
      params: withType(catalogType)
    });
    return response.data;
  },

  createItem: async (data) => {
    const response = await axios.post(`${API_BASE}/items`, data);
    return response.data;
  },

  updateItem: async (id, data) => {
    const response = await axios.put(`${API_BASE}/items/${id}`, data);
    return response.data;
  },

  deleteItem: async (id) => {
    const response = await axios.delete(`${API_BASE}/items/${id}`);
    return response.data;
  },

  setQuantity: async (id, quantity, notes) => {
    const response = await axios.post(`${API_BASE}/items/${id}/set-quantity`, {
      quantity,
      notes: notes || undefined
    });
    return response.data;
  },

  importCsv: async (csv, catalogType = 'consumable') => {
    const response = await axios.post(`${API_BASE}/items/import`, {
      csv,
      catalog_type: catalogType
    });
    return response.data;
  },

  getAudits: async (params = {}, catalogType = 'consumable') => {
    const response = await axios.get(`${API_BASE}/audits`, {
      params: withType(catalogType, params)
    });
    return response.data;
  },

  getAudit: async (id) => {
    const response = await axios.get(`${API_BASE}/audits/${id}`);
    return response.data;
  },

  createAudit: async (data, catalogType = 'consumable') => {
    const response = await axios.post(`${API_BASE}/audits`, {
      ...data,
      catalog_type: catalogType
    });
    return response.data;
  },

  updateAudit: async (id, data) => {
    const response = await axios.patch(`${API_BASE}/audits/${id}`, data);
    return response.data;
  },

  updateAuditLine: async (auditId, lineId, data) => {
    const response = await axios.patch(`${API_BASE}/audits/${auditId}/lines/${lineId}`, data);
    return response.data;
  },

  postAudit: async (id) => {
    const response = await axios.post(`${API_BASE}/audits/${id}/post`);
    return response.data;
  },

  cancelAudit: async (id) => {
    const response = await axios.post(`${API_BASE}/audits/${id}/cancel`);
    return response.data;
  },

  getTransactions: async (params = {}) => {
    const response = await axios.get(`${API_BASE}/transactions`, { params });
    return response.data;
  }
};
